import { render, staticRenderFns } from "./multiCheckbox.vue?vue&type=template&id=54d78c96&scoped=true"
import script from "./multiCheckbox.vue?vue&type=script&lang=js"
export * from "./multiCheckbox.vue?vue&type=script&lang=js"
import style0 from "./multiCheckbox.vue?vue&type=style&index=0&id=54d78c96&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d78c96",
  null
  
)

export default component.exports